import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as routes from '../constants/Routes';
import { useAuth } from '../hooks/useAuth';
import { decodeSafedata } from '../utils/decodeSafeData';

export function PrivateRoute({ children }: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const { player, client } = useAuth();

  // return navigate(`${routes.UNDERLINE}/${client.clientUrl}`);

  useEffect(() => {
    if (!player) navigate(`${routes.UNDERLINE}/${client.clientUrl}`);

    let playerAuthLocal = localStorage.getItem('@pwa:playerAuth');

    if (playerAuthLocal) {
      playerAuthLocal = decodeSafedata(playerAuthLocal);
    }

    const playerAuthparse = playerAuthLocal
      ? JSON.parse(JSON.parse(playerAuthLocal))
      : null;

    // console.log('aqui deu bom', playerAuthparse);

    if (playerAuthparse) {
      const urlsGamified = ['/ranking'];
      const accessUrlGamified = urlsGamified.includes(location.pathname);

      const urlsInfluencer = [
        '/chooseInfluencer',
        '/congratulations',
        '/wellcomeinfluencer',
        '/followers',
        '/profileinfluencer',
        '/detailsInfluencerPlayer',
        '/forgotpasswordInfluencerPlayer',
        '/registergameinfluencers',
        '/validationCode',
      ];
      const accessUrlInfluencer = urlsInfluencer.includes(location.pathname);

      const urlsMgm = ['/prospects', `${routes.UNDERLINE}${routes.CORRETOR}`];
      const accessUrlMgm = urlsMgm.includes(location.pathname);

      if (!player) navigate(`${routes.UNDERLINE}/${client.clientUrl}`);

      if (player && !player.active) {
        return navigate(routes.USER_INACTIVE);
      }

      let phoneWhatsapp = null;

      if (
        client &&
        client.redirectWhatsapp &&
        client.redirectWhatsapp === 'true'
      ) {
        phoneWhatsapp =
          localStorage.getItem('phoneWhatsapp') === 'true' ? true : false;
      }

      const acceptedTerms =
        localStorage.getItem('acceptedTerms') === 'true' ? true : false;

      if (!acceptedTerms) {
        // console.log('!acceptedTerms');
        // return navigate(routes.REGISTER_DETAILS);
      }
      if (
        client &&
        client.redirectWhatsapp &&
        client.redirectWhatsapp === 'true'
      ) {
        if (!phoneWhatsapp) {
          // console.log('!phoneWhatsapp');
          // return navigate(routes.REGISTER_DETAILS);
        }
      }

      if (
        client &&
        client.isGamified &&
        client.isGamified !== 'true' &&
        accessUrlGamified
      ) {
        // console.log('nao tem acesso ao gamificado');
        return navigate(routes.NOT_FOUND);
      }

      if (
        client &&
        client.isTeamCompetition &&
        client.isTeamCompetition !== 'true' &&
        accessUrlInfluencer
      ) {
        // console.log('nao tem acesso ao influencer');
        return navigate(routes.NOT_FOUND);
      }

      if (
        client &&
        client.mgmVinculated &&
        client.mgmVinculated !== 'true' &&
        accessUrlMgm
      ) {
        // console.log('nao tem acesso ao mgm');
        return navigate(routes.NOT_FOUND);
      }
    } else {
      // console.log('nao ta autenticado');
      return navigate(routes.NOT_FOUND);
    }
  }, []);

  return children;
}
